import { rightsSchema } from './common';
import { jFileLittleSchema } from './file';
import { socialActionSchema_deprecated } from './global';
import { jObjectBaseSchema } from './objectBase';
import { jUserLittleSchema } from './user';
import { z } from 'zod';
import { widgetWrapperPropsSchema } from './widgets/default';

export const jCommentLittleSchema = jObjectBaseSchema.omit({ dateModified: true }).extend({
    dateCreation: z.string(),
    dateModified: z.string().nullable(),
    description: z.string().nullable(),
    _user: jUserLittleSchema,
});
export type jCommentLittle = z.infer<typeof jCommentLittleSchema>;

export const jCommentListSchema = jCommentLittleSchema.extend({
    _right: rightsSchema,
    _attachedFiles: z.array(jFileLittleSchema).optional(),
    _actions: z.record(socialActionSchema_deprecated).optional(),
    _widgets: z.array(widgetWrapperPropsSchema).optional(),
});
export type jCommentList = z.infer<typeof jCommentListSchema>;
